var getUF = ({ state }, glossary) => {
  if (glossary) {
    const states = glossary.items.state.items;
    return Object.keys(states).find(uf => states[uf].singular === state);
  }

  return state;
};

export { getUF as default };
//# sourceMappingURL=get-uf.js.map
